import React from 'react';
import { Grid } from '@material-ui/core';
import clsx from 'clsx';

import { AssetIcon, ThreeDotsIcon } from '../icons';
import { AssetStatuses } from 'hooks/useAssets/useAssets.types';
import { useAssetStatus } from 'hooks/useAssetStatus/useAssetStatus';

import { AssetStatusProps } from './AssetStatus.types';
import { useStyles } from './AssetStatus.styles';

const mapThreeDotsColor: Record<
  string,
  'inherit' | 'secondary' | 'error' | 'disabled' | 'action' | 'primary' | undefined
> = {
  [AssetStatuses.ACTIVE]: 'secondary',
  [AssetStatuses.INACTIVE]: 'error',
  [AssetStatuses.INSTALLED]: 'action',
};

export const AssetStatus = ({ status, statusIconClassName }: AssetStatusProps) => {
  const classes = useStyles({ status });
  const { getIconElement } = useAssetStatus();

  const StatusIcon = getIconElement(status) || null;
  const threeDotsColor = mapThreeDotsColor[status] || 'secondary';

  return (
    <Grid item xs={12} alignItems="center" direction="column" container className={classes.statusContainer}>
      <AssetIcon className={classes.assetIcon} />
      <StatusIcon className={clsx(classes.statusIcon, statusIconClassName)} />
      <ThreeDotsIcon className={classes.treeDotIcon} color={threeDotsColor} />
    </Grid>
  );
};
